import { Injectable, inject } from "@angular/core";
import {IssueContentType, IssueType} from "@server-models";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";
import {TechIssueMessageApiService} from "@tech/pages/issues/services/tech-issue-message-api.service";
import {TechIssueMissionApiService} from "@tech/pages/issues/services/tech-issue-mission-api.service";
import {TechIssueTicketApiService} from "@tech/pages/issues/services/tech-issue-ticket-api.service";
import {TechIssueControlMessageApiService} from "@tech/pages/issues/services/tech-issue-control-message-api.service";
import {TechIssueDirectMessageApiService} from "@tech/pages/issues/services/tech-issue-direct-message-api.service";
import {SharedIssueConnectedApiService} from "@shared/components/issues/services/shared-issue-connected-api.service";

@Injectable({
  providedIn: 'root',
})
export class TechIssueService {
  private _techIssuesMessageApiService = inject(TechIssueMessageApiService);
  private _techIssuesDirectMessageApiService = inject(TechIssueDirectMessageApiService);
  private _techIssuesMissionApiService = inject(TechIssueMissionApiService);
  private _techIssuesTicketApiService = inject(TechIssueTicketApiService);
  private _techIssuesControlMessageApiService = inject(TechIssueControlMessageApiService);
  private _techIssueConnectedService = inject(SharedIssueConnectedApiService);


  previewConnected(templateId: number, resourceId?: number) {
    return this._techIssueConnectedService.previewConnected(templateId, resourceId);
  }

  getApiServiceByIssueType(issueType: IssueType): IIssueService {
    switch (issueType) {
      case IssueType.Message:
        return this._techIssuesMessageApiService;
      case IssueType.DirectMessage:
        return this._techIssuesDirectMessageApiService;
      case IssueType.Mission:
        return this._techIssuesMissionApiService;
      case IssueType.Ticket:
        return this._techIssuesTicketApiService;
      case IssueType.ControlMessage:
        return this._techIssuesControlMessageApiService;
      case IssueType.Connected:
        return this._techIssueConnectedService;
      default:
        throw new Error(`Api service, Unsupported issue type: ${ issueType }`);
    }
  }

  getApiServiceByIssueContentType(issueContentType: IssueContentType): IIssueService {
    switch (issueContentType) {
      case IssueContentType.Message:
        return this._techIssuesMessageApiService;
      case IssueContentType.DirectMessage:
        return this._techIssuesDirectMessageApiService;
      case IssueContentType.Mission:
        return this._techIssuesMissionApiService;
      case IssueContentType.Ticket:
        return this._techIssuesTicketApiService;
      case IssueContentType.Connected:
        return this._techIssueConnectedService;
      default:
        throw new Error(`Api service, Unsupported issue content type: ${ issueContentType }`);
    }
  }


}
